import api from './api';

export const getStores = async (departmentId, search = "", page = 1, pageSize = 10, includeInactive = false, phoneNumber = undefined) => {
    try {
        const response = await api.get('/stores', {
            params: { departmentId, search, page, pageSize, includeInactive, phoneNumber }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching stores:', error);
        throw error;
    }
};

export const getStoreByPhone = async (phoneNumber) => {
    try {
        const data = await getStores(undefined, '', 1, 1, false, phoneNumber);
        return data?.items?.[0] || null;
    } catch (error) {
        console.error('Error fetching store by phone:', error);
        throw error;
    }
};

export const createStore = async (storeData) => {
    try {
        const response = await api.post('/stores', storeData);
        return response.data;
    } catch (error) {
        console.error('Error creating store:', error);
        throw error;
    }
};

export const getStoreById = async (id) => {
    try {
        const response = await api.get(`/stores/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching store:', error);
        throw error;
    }
};

export const updateStore = async (id, storeData) => {
    try {
        const response = await api.patch(`/stores/${id}`, storeData);
        return response.data;
    } catch (error) {
        console.error('Error updating store:', error);
        throw error;
    }
};

export const deleteStoreSeller = async (storeId, sellerId) => {
    try {
        await api.delete(`/stores/${storeId}/sellers/${sellerId}`);
    } catch (error) {
        console.error('Error deleting store seller:', error);
        throw error;
    }
};

export const requestStorePhoneChange = async (storeId, phoneNumber) => {
    try {
        await api.post(`/stores/${storeId}/phone`, { phoneNumber });
    } catch (error) {
        console.error('Error requesting store phone change:', error);
        throw error;
    }
};

export const confirmStorePhoneChange = async (storeId, verificationCode) => {
    try {
        const response = await api.post(`/stores/${storeId}/phone/verify`, { verificationCode });
        return response.data;
    } catch (error) {
        console.error('Error confirming store phone change:', error);
        throw error;
    }
};
